import { render, staticRenderFns } from "./toBeReviewed.vue?vue&type=template&id=257d0bd9&scoped=true&"
import script from "./toBeReviewed.vue?vue&type=script&lang=js&"
export * from "./toBeReviewed.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=257d0bd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d0bd9",
  null
  
)

export default component.exports